module.exports = __webpack_public_path__ + "img/R3.ad9cdac4.png";